module.exports = __webpack_public_path__ + "static/media/ic-orders-active.f4989095.svg";